import { render, staticRenderFns } from "./editProfileName.vue?vue&type=template&id=a4e660d6&scoped=true&"
import script from "./editProfileName.vue?vue&type=script&lang=js&"
export * from "./editProfileName.vue?vue&type=script&lang=js&"
import style0 from "./editProfileName.vue?vue&type=style&index=0&id=a4e660d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e660d6",
  null
  
)

export default component.exports